(function () {
  let observer;
  const createObserver = () => {
    // Re-queried on every call (not cached at module scope) -- shopify:section:load replaces
    // this element wholesale while editing in the theme editor, so a stale reference would
    // silently stop reporting height after the first settings change.
    const annBar = document.querySelector(".section-announcement");

    if (observer) observer.disconnect();
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const annBarHeight = annBar?.getBoundingClientRect().height || 0;
            document.documentElement.style.setProperty(
              "--ann-height",
              `${(annBarHeight * entry.intersectionRatio).toFixed(2)}px`
            );
          } else {
            document.documentElement.style.setProperty("--ann-height", "0px");
          }
        });
      },
      {
        threshold: Array.from({ length: 1000 }, (_, i) => i / 1000),
      }
    );

    if (annBar) observer.observe(annBar);
  };

  // Cross-fades between announcement blocks (up to 5, set in theme admin) at the interval
  // configured via section.settings.transition_speed. Interval id is tracked on the module scope
  // (not the element) so a shopify:section:load re-render -- which replaces the whole
  // .announcement-bar__slides element -- can't leave a previous interval running against detached
  // nodes; the theme editor fires this event on every settings change while editing.
  let rotationInterval;
  const initRotation = () => {
    if (rotationInterval) clearInterval(rotationInterval);

    const slidesContainer = document.querySelector(".announcement-bar__slides");
    if (!slidesContainer) return;

    const slides = Array.from(
      slidesContainer.querySelectorAll(".announcement-bar__slide")
    );
    if (slides.length < 2) return;

    const prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReducedMotion) return;

    const speedSeconds =
      parseFloat(slidesContainer.dataset.transitionSpeed) || 5;

    let activeIndex = slides.findIndex((slide) =>
      slide.classList.contains("active")
    );
    if (activeIndex === -1) activeIndex = 0;

    rotationInterval = setInterval(() => {
      slides[activeIndex].classList.remove("active");
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add("active");
    }, speedSeconds * 1000);
  };

  const initAnnBar = () => {
    createObserver();
    initRotation();
  };

  document.addEventListener("shopify:section:load", initAnnBar);
  document.addEventListener("shopify:section:unload", initAnnBar);
  document.addEventListener("shopify:section:reorder", initAnnBar);

  initAnnBar();
})();
